import services from "@/shared/http";
import * as types from "./mutation-types";

/**
 * set checklists
 *
 * @param commit
 * @param payload
 */
export const setChecklistAction = async ({ commit }, payload) => {
  await commit(types.SET_CHECKLISTS, payload);
};


/**
 * set checklists
 *
 * @param commit
 * @param payload
 */
export const setShowLatterChecklistAction = ({ commit }, payload) => {
  commit(types.SET_SHOW_LATTER_CHECKLIST, payload);
};

/**
 * Action to fetch checklists data.
 *
 * @param dispatch
 * @param {boolean} isCached - Whether to check for cached data.
 * @returns {Promise<unknown>}
 */
export const fetchChecklistsAction = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    services.components
      .list()
      .then((checklists) => {
        // Despachar as ações com os dados obtidos da API
        dispatch("setChecklistAction", checklists).finally(resolve); // Resolver a Promise após dispatchar as ações
        resolve()
      })
      .catch((error) => reject(error)); // Rejeitar a Promise se a requisição falhar
  });
};

export const checkUpChecklistAction = ({ dispatch }, payload) => {
  return new Promise((resolve, reject) => {
    services.components
      .verify({ id: payload.id })
      .then(async () => {
        await dispatch("fetchChecklistsAction");
        resolve();
      })
      .catch((error) => reject(error));
  });
};

export const undoChecklistAction = ({ dispatch }, payload) => {
  return new Promise((resolve, reject) => {
    services.components
      .undoVerify({ id: payload.id })
      .then(async () => {
        await dispatch("fetchChecklistsAction");
        resolve();
      })
      .catch((error) => reject(error));
  });
};
export const seenChecklistAction = ({ dispatch }, payload) => {
  return new Promise((resolve, reject) => {
    services.components
      .seen({ id: payload.id })
      .then(async () => {
        await dispatch("fetchChecklistsAction");
        resolve();
      })
      .catch((error) => reject(error));
  });
};


/**
 * Adiciona a rota atual à lista de breadcrumbs.
 * @param {object} commit
 * @param {object} route
 * @returns {void}
*/
export const addRouteToBreadcrumbs = ({ commit }, route) => {
  commit(types.ADD_ROUTE_TO_BREADCRUMBS, route)
};


/**
 * Remove a rota atual da lista de breadcrumbs.
 * @param {object} commit
 * @param {object} routesDetails
 * @returns {void}
*/
export const removeRouteFromBreadcrumbs = ({ commit }, routesDetails) => {
  commit(types.REMOVE_ROUTE_FROM_BREADCRUMBS, routesDetails)
};


/* Força a remontagem de um componente específico */
export const forceRemountComponent = ({ commit }, componentName) => {
  commit(types.FORCE_REMOUNT_COMPONENT, componentName)
}

export const resetAllBreadcrumbs = ({ commit }) => {
  commit(types.RESET_ALL_BREADCRUMBS)
}
